class Model
{
	// Model global object (access via this.sys.game.globals.model):
	// - play sounds and music
	// - local storage
	// - Kongregate API

	constructor()
	{
		this._soundVolume = 1;
		this._musicVolume = 0.75;
		this._music = null;
		this._musicKey = null;
	}

	set soundVolume(value)
	{
		this._soundVolume = value;
		this.saveConfig();
	}

	get soundVolume()
	{
		return this._soundVolume;
	}

	set musicVolume(value)
	{
		this._musicVolume = value;
		this.saveConfig();

		if (this._music)
		{
			if (value == 0)
			{
				this._music.stop();
			}
			else
			{
				this._music.play({ volume: this._musicVolume, loop: true });
			}
		}
	}

	get musicVolume()
	{
		return this._musicVolume;
	}

	set volume(value)
	{
		this._soundVolume = value;
		this._musicVolume = value == 0 ? 0 : 0.75;
		this.saveConfig();

		if (this._music)
		{
			if (value == 0)
			{
				this._music.stop();
			}
			else
			{
				this._music.play({ volume: this._musicVolume, loop: true });
			}
		}
	}

	get volume()
	{
		return this._soundVolume;
	}

	readConfig()
	{
		this._soundVolume = parseFloat(this.getPersistentData("sound") || 1);
		this._musicVolume = parseFloat(this.getPersistentData("music") || 0.75);
	}

	saveConfig()
	{
		try
		{
			localStorage.setItem("sound", this._soundVolume);
			localStorage.setItem("music", this._musicVolume);
		}
		catch (e)
		{
			console.warn("Local storage is not working.");
		}
	}

	getPersistentData(key)
	{
		try
		{
			return localStorage.getItem(key);
		}
		catch (e)
		{
			console.warn("Local storage is not working.");
			return null;
		}
	}

	setPersistentData(key, value)
	{
		localStorage.setItem(key, value);
	}

	removePersistentData(key)
	{
		localStorage.removeItem(key);
	}

	playMusic(scene, key)
	{
		if (this._musicKey == key)
		{
			return;
		}
		if (this._music)
		{
			this._music.stop();
		}
		this._musicKey = key;
		this._music = scene.sound.add(key, { volume: this._musicVolume, loop: true });
		if (this._musicVolume)
		{
			this._music.play();
		}
	}

	playSound(scene, key)
	{
		if (this._soundVolume)
		{
			scene.sound.add(key, { volume: this._soundVolume }).play();
		}
	}

	sendStat(name, value)
	{
		if (kongregate)
		{
			try
			{
				kongregate.stats.submit(name, value);
			}
			catch (e)
			{
				console.warn(e);
			}
		}
	}

	path(path)
	{
		return "../" + path;
	}

	loadImage(scene, key, path)
	{
		scene.load.image(key, require(this.path(path)));
	}

	loadSpriteSheet(scene, key, path, width, height)
	{
		scene.load.spritesheet(key, require(this.path(path)), { frameWidth: width, frameHeight: height });
	}

	loadAudio(scene, key, path)
	{
		scene.load.audio(key, require(this.path(path)));
	}
}

export default Model;